import React from "react";
import { Menu, X } from "lucide-react";

const Header = ({ activeSection, scrollToSection }) => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const navItems = [
    { id: 'home', label: 'Home' },
    { id: 'services', label: 'Services' },
    { id: 'clients', label: 'Clients' },
    { id: 'cofounders', label: 'Team' },
    { id: 'contact', label: 'Contact' },
    { id: 'faq', label: 'FAQ' }
  ];

  return (
    <header className="dark-header">
      <div className="flex items-center">
        <a 
          href="/"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
        >
          <img 
            src="https://customer-assets.emergentagent.com/job_telegramcrypto/artifacts/c1vqzvr8_final%20logo%20TG4Crypto%20black%202.png"
            alt="TG4Crypto"
            className="h-10 w-auto cursor-pointer hover:opacity-80 transition-opacity duration-300"
            style={{ 
              filter: 'brightness(0) saturate(100%) invert(70%) sepia(89%) saturate(2873%) hue-rotate(140deg) brightness(104%) contrast(101%)'
            }}
          />
        </a>
      </div>
      
      {/* Desktop Navigation */}
      <nav className="dark-nav hidden md:flex">
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => {
              if (item.id === 'home') {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              } else {
                scrollToSection(item.id);
              }
            }}
            className={`dark-nav-link ${
              activeSection === item.id ? 'active' : ''
            }`}
          >
            {item.label}
          </button>
        ))}
      </nav>
      
      {/* Mobile Menu Button */}
      <button 
        className="md:hidden p-2"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        style={{ color: 'var(--text-primary)' }}
      >
        {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>
      
      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="absolute top-full left-0 w-full bg-black border-t border-gray-800 md:hidden">
          <nav className="flex flex-col p-4">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => {
                  if (item.id === 'home') {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  } else {
                    scrollToSection(item.id);
                  }
                  setIsMenuOpen(false);
                }}
                className={`dark-nav-link py-2 text-left ${
                  activeSection === item.id ? 'active' : ''
                }`}
              >
                {item.label}
              </button>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;